import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class EventStore {
  loading = false;
  total = 0;
  contentList = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      contentList: observable,

      loadData: action,
      deleteRecord: action,

      addData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, page }) {
    this.loading = true;
    var postData = {
      companyId: 1,
      offset: offset,
      limit: limit,
      page: page,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/taxi_content/getEvent", {
        params: postData,
      });

    this.contentList = response?.data?.contentData;
    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }

  async addData(postData) {
    var eventDetails = { postData };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // const encodedInput = encodeURIComponent(base64Input);

    // console.log(encodedInput);

    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/taxi_content/updateContent", eventDetails);

    return response.data;
  }
  async getEventData(contentId) {
    var postData = { contentId: contentId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/taxi_content/getEvent", {
        params: postData,
      });
    return response?.data?.contentData[0];
  }

  async deleteRecord({ id }) {
    const postData = {
      id: id,
    };
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/taxi_content/deleteContent", {
        params: postData,
      });

    return response;
  }
}

export default EventStore;
